import { use } from "react";

import { TopLevelUserContext } from "./TopLevelUserContext";

export const useTopLevelUser = () => use(TopLevelUserContext);
